import { useQuery } from '@apollo/client'
import { Col, Row, Space } from 'antd'
import React from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { LeadActivities, LeadAssignee, LeadInfo, LeadRemarks, LeadStatusFlow } from '../../components'
import { GET_LEAD } from '../../Graphql/queries/getQueries'
import Template from '../../Template'

const LeadDetail = () => {
    const { lead_id } = useParams()

    return (
        <Template
            useGoBack
            headerTitle={['Enquiry Dashboard', 'lead detail']}
        >
            <Row gutter={[16, 32]} >
                <Col xs={{ span: 24 }} md={{ span: 16 }}   >
                    <Space direction="vertical" size={40} style={{ width: '100%' }}>
                        <Row >
                            <Col span={24}>
                                <LeadInfo leadId={lead_id} />
                            </Col>
                        </Row>
                        <Row >
                            <Col span={24} >
                                <LeadStatusFlow leadId={lead_id} />
                            </Col>
                        </Row>
                        <Row gutter={[30, 30]} >
                            <Col xs={{ span: 24 }} xxl={{ span: 10 }} >
                                <LeadAssignee leadId={lead_id} />
                            </Col>
                            <Col xs={{ span: 24 }} xxl={{ span: 14 }} >
                                <LeadRemarks leadId={lead_id} />
                            </Col>
                        </Row>
                    </Space>

                </Col>
                <Col xs={{ span: 24 }} md={{ span: 8 }} >
                    <LeadActivities leadId={lead_id} />
                </Col>
            </Row>
        </Template>
    )
}

export default LeadDetail